import React from 'react';
import { t } from '../../../../modules/infra/i18n';

import * as shapes from '../../shapes';

const ProductNavigation = ({
  hasFilters,
  categoryName,
  brandName,
  resetFilters,
}) => (
  <div className="layout layout--small layout--auto layout--middle">
    <div className="layout__item" display-if={hasFilters}>
      <button
        type="button"
        className="c-btn c-btn--outline c-btn--outline-grey u-mr"
        onClick={resetFilters}
      >
        {t('register:sale.product_navigation.back')}
      </button>
    </div>
    <div className="layout__item" display-if={categoryName}>
      <h4>{t('register:sale.product_navigation.category_prefix')}{categoryName}</h4>
    </div>
    <div className="layout__item" display-if={brandName}>
      <h4>{t('register:sale.product_navigation.brand_prefix')}{brandName}</h4>
    </div>
  </div>
);
ProductNavigation.propTypes = {
  hasFilters: shapes.flag.isRequired,
  categoryName: shapes.string,
  brandName: shapes.string,
  resetFilters: shapes.handler.isRequired,
};
ProductNavigation.defaultProps = {
  categoryName: '',
  brandName: '',
};

export default ProductNavigation;
